import { watch } from 'vue';
import { createSharedComposable } from '@vueuse/core';
import { useUpc } from '@nuxt-common/media-card-large/app/composables/useUpc';
import { usePageData } from '~/composables/usePageData';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import useMarxentCta from '~/modules/marxent/composables/useMarxentCta';
import useProductImagesCtaActions from '~/composables/useProductImagesCta/useProductImagesCtaActions';
import useSelectedMemberId from '~/modules/latchkey/composables/useSelectedMemberId';
import { useDeviceType } from '~/composables/utils/useDeviceType';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';

export const useWebAr = createSharedComposable((sortedList = []) => {
  // TODO migrate away from shared composable
  const { addCtaItem, removeCtaItem, updateCtaItem } = useProductImagesCtaActions();
  const { productId } = usePageData();
  const selectedMemberId = useSelectedMemberId();
  const { isShopTheSetExpEnabled } = useFeatureEligibility();
  const { selectedUpcNumber } = useUpc(isShopTheSetExpEnabled ? selectedMemberId : productId);
  const { killswitches } = useKillswitches();
  const { isArEligible, marxentCtaConfig, setCtaConfig, autoStartMarxentExperience } = useMarxentCta();
  const { isDesktop } = useDeviceType();

  /**
    Function to separate update marxent cta logic
  */
  const checkMarxent = (config) => {
    if (sortedList.value.some((obj) => obj.id === 'marxent')) {
      updateCtaItem('marxent', config);
    } else {
      addCtaItem(config);
    }
  };

  /**
    Function responsible for checking marxent KS, setting config for adding/updating CTA
    check if marxent isEligible
  */

  const webArCheck = async () => {
    // If web ar kill switch is on, then we check if selected upc is ar eligible
    if (!killswitches.isBigTicketWebAREnabled) return;

    await setCtaConfig();

    if (!isArEligible.value) {
      removeCtaItem('marxent');
      return;
    }

    checkMarxent(marxentCtaConfig.value);

    if (!isDesktop.value) {
      autoStartMarxentExperience();
    }
  };

  const initialPromise = webArCheck();
  watch([selectedUpcNumber, isArEligible], webArCheck);

  return initialPromise;
});
